export enum LayoutViewType {
    GRID = 'grid',
    LIST = 'list',
    TABLE = 'table'
}
